<template>
    <div>
        <b-form-group
            id="input-group-1"
            :label="field.label"
            :label-for="labelId"
        >
            <b-form-input
                :id="labelId"
                type="text"
                required
                autocomplete="no"
                :placeholder="field.placeholder"
            ></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    props: {
        field: {
            type: Object,
            default: null,
        },
    },
    computed: {
        labelId() {
            return 'input-' + _.kebabCase(this.field.label)
        },
    },
}
</script>
